module.exports = __webpack_public_path__ + "static/img/fletcher-thomas.80f4089.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fletcher-thomas.jpg
// module id = Lp7p
// module chunks = 0